import * as _ from "lodash";
import * as React from "react";

import * as Models from "../../../Models";
import { linkToRelativeUrl } from "../../../Helpers/links";

const LinkItems: React.FC<Models.LinkItemsProps> = (
    props: Models.LinkItemsProps
) => {
    return (
        <ul className="list-unstyled">
            {_.map(props.links, (link: Models.Link, index: Number) => {
                return (
                    <li key={index.toString()}>
                        {link.additionalInfo &&
                            !link.additionalInfo
                                .toLowerCase()
                                .startsWith("customer") &&
                            !link.url.toLowerCase().startsWith("lf") && (
                                <span className="Links__additionalInfo">{`${link.additionalInfo}`}</span>
                            )}

                        {link.url && (
                            <a
                                href={linkToRelativeUrl(link)}
                                onClick={(e) => {
                                    props.selectLink(e, link);
                                }}
                            >
                                <span>{link.description}</span>
                            </a>
                        )}

                        {!link.url && <span>{link.description}</span>}
                    </li>
                );
            })}
        </ul>
    );
};

export const LinkCardContent: React.FC<Models.LinkCardContentProps> = (
    props: Models.LinkCardContentProps
) => {
    const linksWithoutSalesOrders: Models.LinkCollection[] = _.filter(
        props.links,
        (l) => !l.description.toLowerCase().startsWith("sales")
    );

    return (
        <div className="Links__group">
            {_.map(
                linksWithoutSalesOrders,
                (links: Models.LinkCollection, index: Number) => {
                    return (
                        <div className="Links__list" key={index.toString()}>
                            <h3>{links.description}</h3>
                            <LinkItems
                                links={links.urls}
                                selectLink={props.selectLink}
                            />
                            {links.urls.length === 0 && (
                                <p className="small">No data</p>
                            )}
                        </div>
                    );
                }
            )}
        </div>
    );
};
